import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { KeywordsService } from 'src/app/shared/API-Service/services/keywords.service';


@Component({
  selector: 'app-insert-keywords',
  templateUrl: './insert-keywords.component.html',
  styleUrls: ['./insert-keywords.component.css']
})
export class InsertKeywordsComponent implements OnInit {
  recordtoupdate: any;
  cities:any;
  keyword:any;
  keywordForm:FormGroup;
  update:boolean = false;
  button:boolean = false;
  constructor(private _KeywordsService:KeywordsService, private _Router:Router,private _FormBuilder:FormBuilder) { }

  ngOnInit(): void {
    this.initiate();
    this.checkEdit();
  }

  initiate(){
    this.keywordForm = this._FormBuilder.group({
      title: ['', Validators.required]
    });
  }
  get fc() {
    return this.keywordForm.controls;
  }
  checkEdit() {
    this._KeywordsService.Data.subscribe((res) => {
      if (res != null) {
        this.keywordForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
          
        });
        this.update = true;
        this.recordtoupdate = res ;
        console.log(this.recordtoupdate);
      } else {
        console.log(`not found on data`);
      }
     
    });
  }
  onSubmit(){
    this.button = true;
  if(this.update == false && this.keywordForm.status == "VALID"){
    this._KeywordsService.Createkeywords(this.keywordForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.keywordForm.reset();
      this._Router.navigate(['/content/admin/ViewKeywords']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
  } else if(this.keywordForm.status == "VALID"){
    this.keywordForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._KeywordsService.Updatekeywords(this.keywordForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.keywordForm.reset();
      this._Router.navigate(['/content/admin/ViewKeywords']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
  }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.keywordForm.markAllAsTouched();
    this.button = false;
  }
  }

  ngOnDestroy(){
    this._KeywordsService.Data.next(null);
    }

}
